export const hierarchyOptions = [
  { key: 1, text: '1' },
  { key: 2, text: '2' },
  { key: 3, text: '3' },
];

